import { Dispatch, SetStateAction } from 'react'

import { BillingSearchCondition } from '@/common/api/modules/billing'
import {
  ListFollowTableHeaderProps,
  makeRectPropsForTableHeadItem,
  useListScrollFollow
} from '@/common/app/list'
import { BillingRecord } from '@/common/model/ugcBilling'

import TableHeadItem from '@/components/view/atoms/table/TableHeadItem'
import Text, { TextColor } from '@/components/view/atoms/text/Text'

import BillingListRow from '@/components/container/modules/admin/billing/table/BillingListRow'
import ScrollFollowTable from '@/components/container/utils/list/ScrollFollowTable'

interface TheadProps extends ListFollowTableHeaderProps {
  float?: boolean
}

const Thead = ({ rowRefs, rowRects, float = false }: TheadProps) => {
  const rectProps = (index: number) =>
    makeRectPropsForTableHeadItem(rowRefs, rowRects, index, float)

  return (
    <>
      <TableHeadItem float={float} {...rectProps(0)}>
        <Text size={12} color={TextColor.SECONDARY}>月</Text>
      </TableHeadItem>
      <TableHeadItem float={float} {...rectProps(1)}>
        <Text size={12} color={TextColor.SECONDARY}>サイト</Text>
      </TableHeadItem>
      <TableHeadItem float={float} {...rectProps(2)}>
        <Text size={12} color={TextColor.SECONDARY}>プラン</Text>
      </TableHeadItem>
      <TableHeadItem float={float} {...rectProps(3)}>
        <Text size={12} color={TextColor.SECONDARY}>基本料金</Text>
      </TableHeadItem>
      <TableHeadItem float={float} {...rectProps(4)}>
        <Text size={12} color={TextColor.SECONDARY}>従量料金</Text>
      </TableHeadItem>
      <TableHeadItem float={float} {...rectProps(5)}>
        <Text size={12} color={TextColor.SECONDARY}>合計</Text>
      </TableHeadItem>
      <TableHeadItem float={float} {...rectProps(6)}>
        <Text size={12} color={TextColor.SECONDARY}>UGC数</Text>
      </TableHeadItem>
      <TableHeadItem float={float} {...rectProps(7)}>
        <Text size={12} color={TextColor.SECONDARY}>ステータス</Text>
      </TableHeadItem>
    </>
  )
}

interface Props {
  records: BillingRecord[]
  condition: BillingSearchCondition
  setCondition: Dispatch<SetStateAction<BillingSearchCondition>>
  onUpdatePage: (page: number) => void
  total: number
}

const COLUMN_LENGTH = 8

const BillingListTable = ({ records, condition, onUpdatePage, total }: Props) => {
  const listFollowProps = useListScrollFollow(COLUMN_LENGTH)
  const { header } = listFollowProps

  const theadProps: TheadProps = { ...header }

  return (
    <ScrollFollowTable
      listFollowProps={listFollowProps}
      tableHead={<Thead {...theadProps} />}
      tableFloatHead={<Thead {...theadProps} float />}
      body={
        <>
          {records.map((record) => (
            <BillingListRow key={record.id} record={record} isScrolled={header.isScrolled} />
          ))}
        </>
      }
      condition={condition}
      onUpdatePage={onUpdatePage}
      total={total}
    />
  )
}

export default BillingListTable
